import type { RoomDetail } from '../hooks/useCreateBooking';
import type { RoomTypesQuery } from '../gql/graphql';

export const PAYMENT_DRAFT_STORAGE_KEY = 'santtai.paymentCheckoutDraft';

export type PaymentLocationState = {
  boatName: string;
  tripDate: string;
  /** ISO embarkation date (yyyy-MM-dd) for pay-later deadline math. */
  embarkationDate?: string;
  routeName: string;
  numberOfDays: number;
  numberOfNights: number;
  numberOfDives: number;
  tripId: number;
  boatId: number;
  selectedRooms: RoomDetail[];
  boatRooms: RoomTypesQuery | undefined;
  currency: string;
};

export const savePaymentDraft = (state: PaymentLocationState): void => {
  try {
    sessionStorage.setItem(PAYMENT_DRAFT_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Ignore quota / private-mode failures — checkout still works via location.state.
  }
};

export const loadPaymentDraft = (): PaymentLocationState | null => {
  try {
    const raw = sessionStorage.getItem(PAYMENT_DRAFT_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as PaymentLocationState;
    if (!parsed?.tripId || !parsed?.selectedRooms?.length) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const clearPaymentDraft = (): void => {
  try {
    sessionStorage.removeItem(PAYMENT_DRAFT_STORAGE_KEY);
  } catch {
    // no-op
  }
};
